import React from 'react'
import styled, { css } from 'styled-components'

const width = '27'
const height = '27'
const viewBox = '0 0 27 27'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <g fill="none" fillRule="evenodd" transform="translate(1 1)" key="key-0">
      <path
        fill="#FFF"
        d="M8.48 7.312c1.68 0 2.933 1.223 2.933 2.858 0 1.65-1.253 2.872-2.933 2.872-1.672 0-2.925-1.222-2.925-2.872 0-1.635 1.253-2.858 2.925-2.858zm0 1.568c-.727 0-1.26.54-1.26 1.29 0 .757.533 1.305 1.26 1.305.743 0 1.268-.548 1.268-1.305 0-.75-.525-1.29-1.268-1.29zM9.875 18H7.91l7.043-10.5h1.957L9.875 18zm6.488-5.543c1.68 0 2.932 1.223 2.932 2.865 0 1.643-1.252 2.866-2.932 2.866-1.673 0-2.925-1.223-2.925-2.866 0-1.62 1.252-2.865 2.925-2.865zm0 1.568c-.728 0-1.26.547-1.26 1.297 0 .75.532 1.298 1.26 1.298.742 0 1.267-.548 1.267-1.298s-.525-1.297-1.267-1.297z"
      />
      <circle cx="12.5" cy="12.5" r="12.5" stroke="#FFF" strokeWidth="2" />
    </g>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconOffer'
})
